import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Form, FormikErrors } from "formik";
import React from "react";
import theme from "utils/theme";
import DurationSection from "./DurationSection";
import FormActions from "./FormActions";
import GeneralSection from "./GeneralSection";
import { getMonthlyPeriods } from "./helper/periodHelpers";
import LimitSection from "./LimitSection";
import NotificationSection from "./NotificationSection";
import ServicesSection from "./ServicesSection";
import { ApiKey, ServiceProductCreatable } from "./types";
const useStyles = makeStyles({
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: 690,
    padding: theme.spacing(3),
    gap: theme.spacing(3),
    backgroundColor: "#ffffff",
    boxShadow: "0px 1px 16px 0px rgba(0, 0, 0, 0.3)"
  },
  header: {
    fontFamily: "Segoe UI !important",
    fontWeight: "400 !important",
    fontSize: "20.74px !important",
    lineHeight: "27px !important",
    letterSpacing: 0,
    color: "#1E1E1E !important",
    paddingBottom: theme.spacing(0, 2),
    gap: 10
  },
  content: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: theme.spacing(3)
  }
});

interface ServiceProductFormContentProps {
  values: Partial<ServiceProductCreatable>;
  setFieldValue: (
    field: string,
    value: unknown,
    shouldValidate?: boolean
  ) => void;
  errors: FormikErrors<ServiceProductCreatable>;
  singlePeriod: boolean;
  handleSinglePeriodChange: (
    val: boolean,
    setFieldValue: (field: string, value: unknown) => void
  ) => void;
  apiKeys: ApiKey[];
  availableProductServices: string[];
  isSubmitting: boolean;
  solutionKey: Key;
}

const ServiceProductFormContent: React.FC<ServiceProductFormContentProps> = ({
  values,
  setFieldValue,
  errors,
  singlePeriod,
  handleSinglePeriodChange,
  ...props
}) => {
  const classes = useStyles();
  return (
    <Form className={classes.form}>
      <Typography variant="h6" gutterBottom className={classes.header}>
        Create Service Product
      </Typography>
      <div className={classes.content}>
        <GeneralSection
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
          apiKeys={props.apiKeys}
        />
        <ServicesSection
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
          availableProductServices={props.availableProductServices}
        />
        <DurationSection
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
          singlePeriod={singlePeriod}
          onSinglePeriodChange={(val: boolean) =>
            handleSinglePeriodChange(val, setFieldValue)
          }
          getMonthlyPeriods={getMonthlyPeriods}
        />
        <LimitSection
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
        />
        <NotificationSection
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
          limitType={values.limitType}
        />
      </div>
      <FormActions
        isSubmitting={props.isSubmitting}
        solutionKey={props.solutionKey}
      />
    </Form>
  );
};

export default ServiceProductFormContent;
